import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { buildRoutePath, routes } from '../../../constants/routes'

const mapStateToProps = (state) => {
    return {
        keyIssueCategories: state.keyIssueCategories
    }
}

const KeyIssuePreview = ({ classes, keyIssue, keyIssueCategories }) => {
    const cleanAlias = keyIssue?.alias.replace(/\/key-issues\//, '')
    const color = keyIssueCategories?.find(c => c.name === keyIssue?.category)?.color

    // NOTE: Key issue summaries were not re-imported, adding this for testing / demo purposes
    let summary = keyIssue.summary || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    return (
        <div className={`key-issue-preview ${color} ${classes || ''}`}>
            <div className="chip" style={{ backgroundImage: `url(${keyIssue.thumbnail.url})` }} />
            <div className={`label ${color}-bg`} >
                <title>{keyIssue.title}</title>
                <div className="summary">
                    <p>{summary}</p>
                    <Link target="_blank" className="link" to={buildRoutePath(routes.keyIssueOverview.path, { keyIssueSlug: cleanAlias })}>Explore</Link>
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(KeyIssuePreview)
